import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import checkValidity from '../../utils/validation';
import { signup } from '../../utils/sideEffects';
import { loginUrl } from '../../constants/appUrls';
import AuthContext from '../../contexts/AuthContext';

import Button from '../../components/UI/Button';
import Input from '../../components/UI/Input';
import Spinner from '../../components/UI/Spinner';

class SignUp extends Component {

    static contextType = AuthContext;

    state = {
        signUpForm: {
            firstName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'First Name',
                },
                value: '',
                validation: {
                    required: true,
                },
                isValid: false,
                touched: false,
            },
            lastName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Last Name',
                },
                value: '',
                validation: {
                    required: true,
                },
                isValid: false,
                touched: false,
            },
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: 'E-mail',
                },
                value: '',
                validation: {
                    isEmail: true,
                    required: true,
                },
                isValid: false,
                touched: false,
            },
            contact: {
                elementType: 'input',
                elementConfig: {
                    type: 'number',
                    placeholder: 'Contact',
                },
                value: '',
                validation: {
                    minLength: 10,
                    maxLength: 10,
                    required: true,
                },
                isValid: false,
                touched: false,
            },
            password: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Password',
                    autoComplete: '',
                },
                value: '',
                validation: {
                    isPassword: true,
                    minLength: 8,
                    required: true,
                },
                isValid: false,
                touched: false,
            },
            confirmPassword: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Confirm Password',
                    autoComplete: '',
                },
                value: '',
                validation: {
                    isPassword: true,
                    minLength: 8,
                    required: true,
                },
                isValid: false,
                touched: false,
            },
        },
        isFormValid: false,
        isLoading: false,
        error: null,
    }

    formSubmitHandler = async event => {
        this.setState({ isLoading: true });
        event.preventDefault();
        let formData = {};
        for (let key in this.state.signUpForm) {
            formData = {
                ...formData,
                [key]: this.state.signUpForm[key].value
            }
        }
        const result = await signup(formData);
        if (result.status !== 201) {
            this.setState({ error: result.data, isLoading: false });
        } else {
            this.props.history.replace(loginUrl);
        }
    }

    inputChangeHandler = (key, event) => {
        const form = { ...this.state.signUpForm };
        const element = { ...form[key] };
        element.value = event.target.value;
        element.isValid = checkValidity(event.target.value, element.validation);
        element.touched = true;
        form[key] = element;
        let isFormValid = true;
        for (key in form) {
            isFormValid = form[key].isValid && isFormValid;
        }
        this.setState({ signUpForm: form, isFormValid: isFormValid });
    }

    componentDidMount() {
        if (this.context.isLoggedIn) {
            this.props.history.replace('/');
        }
    }

    render() {

        const formElements = [];
        for (let key in this.state.signUpForm) {
            formElements.push({
                id: key,
                config: this.state.signUpForm[key]
            })
        }

        let form = <form className="form" onSubmit={this.formSubmitHandler}>
            <h1 className="form__title">SIGN UP</h1>
            {this.state.error && <p className="form__error">{this.state.error.status}: {this.state.error.message}</p>}
            {formElements.map(element => {
                return <Input
                    key={element.id}
                    elementType={element.config.elementType}
                    value={element.config.value}
                    isValid={element.config.isValid}
                    touched={element.config.touched}
                    elementConfig={element.config.elementConfig}
                    changed={(event) => { this.inputChangeHandler(element.id, event) }} />
            })}
            <Button className="btn form__btn" type="submit">Register</Button>
            <p className="form__link">Already have an account? <NavLink to={loginUrl}><span>Login</span></NavLink></p>
        </form>;

        if (this.state.isLoading) {
            form = <Spinner />
        }

        return form;
    }


}

export default SignUp;